<template>
  <div>
    <v-expansion-panel-header
      class="pa-0 ma-0 app-list-card-expansion-header"
      v-if="order"
    >
      <div
        class="d-flex algin-center justify-center justify-space-between py-1 px-0 app-relative"
      >
        <!-- <v-chip

          x-small
          label
          pill
   
          class="px-1 text-lowercase"
        >
          {{ order.order_segment }}
        </v-chip> -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="text-caption mr-1 font-weight-bold pl-2"
              v-if="order.reference_number"
              v-bind="attrs"
              v-on="on"
            >
              {{ order.reference_number }}
            </span>
          </template>
          <span class="text-capitalize">reference number</span>
        </v-tooltip>

        <CopyToClipboard
          :textTobeCopied="order.reference_number"
          iconClass="ml-2"
        />
        <!-- <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="order.reference_number"
              v-bind="attrs"
              v-on="on"
              color="primary"
              small
              class="ml-2"
              @click.stop="copyContentToClipboard(order.reference_number)"
              >mdi-content-copy</v-icon
            >
          </template>
          <span class="text-capitalize">Copy to clipboard</span>
        </v-tooltip> -->

        <v-spacer></v-spacer>

        <div v-if="order && order.warning && order.warning.message">
          <v-tooltip right color="error" max-width="200">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon class="pr-3" color="error" small>
                  mdi-information
                </v-icon>
              </div>
            </template>
            <span class="text-capitalize">{{ order.warning.message }}</span>
          </v-tooltip>
        </div>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-chip
                class="mr-1 text-capitalize font-weight-bold"
                :class="$helper.getOrderStatusColor(order.status, true)"
                x-small
                v-if="order.verbose_status"
              >
                {{ order.verbose_status }}
              </v-chip>
            </div>
          </template>
          <span class="text-capitalize"> {{ statusMapping.orderStatus }} </span>
        </v-tooltip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="px-0 py-2" v-if="order">
      <v-row no-gutters @click="$emit('selectedOrder', order)">
        <v-col cols="6" class="">
          <OrderTooltipWithIcon
            v-if="order.execution_date"
            icon=" mdi-calendar-range"
            :text="order.execution_date"
            :label="`${orderModule.order} date`"
          />
        </v-col>
        <v-col cols="6" class="text-right">
          <OrderTooltipWithIcon
            v-if="order.contact_number"
            icon="mdi-phone"
            :text="order.contact_number"
            label="contact name"
          />
        </v-col>

        <v-col
          cols="4"
          class=""
          v-if="
            userDetails &&
            userDetails.company_details &&
            userDetails.company_details.configuration &&
            userDetails.company_details.configuration.has_items
          "
        >

          <OrderTooltipWithIcon
            v-if="order.total_items"
            icon="mdi-inbox-multiple"
            :text="order.total_items"
            label="total items"
          />
        </v-col>
        <!-- <v-col cols="4" class="" v-else-if="order.total_items">
          <OrderTooltipWithIcon
            v-if="order.total_items"
            icon="mdi-inbox-multiple"
            :text="order.total_items"
            label="total items"
          />
        </v-col> -->
        <v-col cols="8" class="d-flex">
          <OrderTooltipWithIcon
            v-if="order.volume"
            icon="mdi-package-variant-closed"
            :text="order.volume"
            :label="`${orderModule.order} volume`"
          />
          <span class="mr-6"></span>
          <OrderTooltipWithIcon
            v-if="order.weight"
            icon="mdi-weight"
            :text="order.weight"
            :label="`${orderModule.order} weight`"
          />
        </v-col>
        <v-col cols="6" class="">
          <OrderTooltipWithIcon
            v-if="order.customer_name"
            icon="mdi-account"
            :text="order.customer_name"
            :label="`${customerModule.customer} name`"
          />
        </v-col>
        <v-col cols="12" class="">
          <OrderTooltipWithIcon
            v-if="order.address"
            icon="mdi-map-marker"
            :text="order.address"
            :label="`${customerModule.customer} Address`"
          />
        </v-col>
        <v-col cols="6">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                label
                x-small
                color="error"
                v-bind="attrs"
                v-on="on"
                class="mr-2 px-2"
              >
                <b>{{ order.order_segment }}</b>
              </v-chip>
            </template>
            <span class="text-capitalize">Order Segment</span>
          </v-tooltip>
          <v-tooltip bottom v-if="order.order_segment == 'SALES'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                label
                x-small
                v-bind="attrs"
                v-on="on"
                class="px-2"
                :color="order.order_type == 'Pickup' ? 'warning' : 'success'"
              >
                <b>{{ order.order_type }}</b>
              </v-chip>
            </template>
            <span class="text-capitalize">Order Type</span>
          </v-tooltip>
        </v-col>
        <v-col
          cols="6"
          class="text-right"
          v-if="order && orderStatus && order.status == orderStatus.UNASSIGNED"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                label
                x-small
                color="primary"
                v-bind="attrs"
                v-on="on"
                v-if="
                  userDetails &&
                  userDetails.company_details &&
                  userDetails.company_details.configuration &&
                  userDetails.company_details.configuration.has_items
                "
                class="ml-2 px-2"
                @click.stop="
                  $router.push({
                    name: 'order-item-split',
                    params: {
                      id: order.id,
                    },
                  })
                "
              >
                <b>Split</b>
              </v-chip>
              <v-chip
                v-else
                label
                x-small
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="ml-2 px-2"
                @click.stop="
                  $router.push({
                    name: 'order-split',
                    params: {
                      id: order.id,
                    },
                  })
                "
              >
                <b>Split</b>
              </v-chip>
            </template>
            <span class="text-capitalize">{{ orderModule.order }} Split</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import OrderTooltipWithIcon from "@/components/ModuleBasedComponents/Order/OrderTooltipWithIcon.vue";
import { orderStatus } from "@/utils/fieldConstants";
import {
  customerModule,
  orderModule,
  statusMapping,
} from "@/utils/moduleMapping";
import CopyToClipboard from "@/components/GeneralComponents/CopyToClipboard.vue";
export default {
  components: {
    OrderTooltipWithIcon,
    CopyToClipboard,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      orderStatus,
      statusMapping,
      customerModule,
      orderModule,
    };
  },
  computed: {
    userDetails() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj;
      }
    },
  },
};
</script>
